export default __webpack_public_path__ + "static/media/DEUS.19bae3f6.png";